<template>
  <OrderDetailDeleteRequest :onDeleteOrder="confirmDeleteOrder" />
</template>

<script>
import OrderDetailDeleteRequest from '../../layouts/organisms/OrderDetailDeleteRequest/index'
import { Action, Location } from '../../../../../plugins/AppManager'
import { NativeStorageKey } from '../../../../../plugins/NativeStorageManager'

import { LogScreenName, LogType, LogGroup, LogEvent } from '@/plugins/AppLogManager'

export default {
  name: 'OrderDetailDeleteRequestContainer',
  components: { OrderDetailDeleteRequest },
  computed: {
    orderId() {
      return this.$store.getters['myOrderHistoryDetailV2/orderDetail'].summary.orderId
    }
  },
  methods: {
    async confirmDeleteOrder() {
      this.$store.dispatch('modal/open', {
        type: 'Confirm',
        message: '선택한 주문내역을 삭제하시겠습니까? 삭제 후에는 복구할 수 없습니다.',
        onOK: async () => {
          this.$store.dispatch('modal/close')
          this.deleteOrder()
        },
        onCancel: async () => {
          this.$store.dispatch('modal/close')
          this.ordDetailDeleteCancelLog()
        }
      })
    },
    async deleteOrder() {
      const { failed, message, code } = await this.$store.dispatch(
        'myOrderHistoryDetailV2/deleteOrder',
        {
          orderId: this.orderId
        }
      )

      if (code === '401') {
        this.$store.dispatch('modal/open', {
          type: 'Check',
          message,
          onOK: async () => {
            this.$store.dispatch('modal/close')
            this.$appManager.action(Action.REFRESH_TOKEN)

            if (this.$store.getters.isAndroid) {
              this.$appManager.action(Action.CLOSE)
            }

            setTimeout(() => {
              this.$appManager.action(Action.CLOSE)
            }, 150)
          },
          onCancel: async () => {}
        })

        return
      }

      if (failed) {
        this.$store.dispatch('modal/open', {
          type: 'Check',
          message,
          onOK: async () => {
            this.$store.dispatch('modal/close')
          },
          onCancel: async () => {}
        })

        return
      }

      this.ordDetailDeleteLog()

      if (this.$nativeStorageManager.unavailable) {
        this.$appManager.action(Action.CLOSE)
      }

      await this.$nativeStorageManager.set(
        NativeStorageKey.BAEMIN_MARKET_DELETED_ORDER_ID,
        this.orderId
      )
      this.$appManager.action(Action.CLOSE)
    },
    ordDetailDeleteLog() {
      const { orderId, shopId } = this.$store.getters['myOrderHistoryDetailV2/orderDetail'].summary

      const params = {
        OrdNo: String(orderId),
        ShopNo: String(shopId)
      }

      // M4-1
      this.$appLogManager.post({
        screenName: LogScreenName.MARKET_ORD_HIST,
        type: LogType.CLICK,
        group: LogGroup.ORD,
        event: LogEvent.DEL_ORD,
        params
      })
    },
    ordDetailDeleteCancelLog() {
      const { orderId, shopId } = this.$store.getters['myOrderHistoryDetailV2/orderDetail'].summary

      const params = {
        OrdNo: String(orderId),
        ShopNo: String(shopId)
      }

      // M4-2
      this.$appLogManager.post({
        screenName: LogScreenName.MARKET_ORD_HIST,
        type: LogType.CLICK,
        group: LogGroup.ORD,
        event: LogEvent.DEL_ORD_CNCL,
        params
      })
    }
  }
}
</script>
